import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, useAttrs, useListeners } from "vue"
import { CompaniesSearchQuery } from "@/gql"

interface Attrs {
  label?: string
  [key: string]: any
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyCombo',
  setup(__props) {

const search = ref<string | null>(null)

const attrs = useAttrs()
const listeners = useListeners()

const hasOutlined = computed(() => Object.prototype.hasOwnProperty.call(attrs, "outlined"))
const filteredAttrs = computed(() => {
  if (hasOutlined.value) {
    const { label, ...rest } = attrs as Attrs
    return rest
  }
  return attrs as Attrs
})

return { __sfc: true,search, attrs, listeners, hasOutlined, filteredAttrs, CompaniesSearchQuery }
}

})